import React from "react";
import { pillars } from "../data/content";
export function Approach() {
  return <section id="enfoque" className="scroll-mt-20 bg-paper text-ink" data-id="element-21" data-mp="uddiqkt7dee0">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-32" data-id="element-22" data-mp="ub0u5osxw5rz">
        <div className="max-w-2xl" data-id="element-23" data-mp="qcbgdv3zom7t">
          <p className="text-sm font-medium text-gold-deep" data-id="element-24" data-mp="q95rafvd1kc3">Nuestro enfoque</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-25" data-mp="le9zngu1cyzi">
            Tres pilares que guían cada decisión.
          </h2>
        </div>

        <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-10" data-id="element-26" data-mp="1e0unw8f7suyu">
          {pillars.map(pillar => <article key={pillar.title} className="border-t-2 border-gold pt-8" data-id="element-27" data-mp="190yj46yp0zi8">
              <h3 className="text-2xl font-semibold" data-id="element-28" data-mp="143q3ad10p7k5">{pillar.title}</h3>
              <p className="mt-4 leading-relaxed text-ink/75" data-id="element-29" data-mp="3ts8wekou0oe2">{pillar.description}</p>
            </article>)}
        </div>
      </div>
    </section>;
}